import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddCategoryApi } from "./Catagory.action";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import { useTranslation } from "react-i18next";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
// import { getWarehouseApi } from "../Warehouse/Warehouse.action";
import _ from "lodash";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddCategory = (props) => {
  const { t } = useTranslation();
  // const [wareHouseId, setWarehouseId] = useState();
  // const [warehouseName, setWarehouseName] = useState("");
  const [retaurantId, setRestaurantId] = useState();
  const [restaurantName, setRestaurantName] = useState();
  const [category, setCategoryName] = useState();
  // const [categoryType, setCategoryType] = useState();


  function uploadCategory() {
    props.AddCategoryApi({
      name: category,
      retaurantId: retaurantId,
    },
      showSuccessAlert,
      showErrorAlert
    );
    setRestaurantId("");
    setRestaurantName("");
    setCategoryName("");
    // setCategoryType("");
  }

  // const handleChangeWarehouse = (selectedOption) => {
  //   setWarehouseId(selectedOption.value);
  //   setWarehouseName(selectedOption.label);
  // };
  // const getWarehouseList = !_.isEmpty(props.warehouseList.data) && props.warehouseList.data.map((x) => {
  //   let data = { value: x._id, label: x.businessName };
  //   return data;
  // });

  const handleChangeRestaurant = (selectedOption) => {
    setRestaurantId(selectedOption.value);
    setRestaurantName(selectedOption.label);
  };
  const getRetaurantList = props.restaurantDataList?.length ? props.restaurantDataList.map(x => ({
    value: x._id,
    label: x.restaurantName,
  })) : [];


  // let categoryTypeData = [{
  //   id: "Store",
  //   type: "Store",
  // },
  // {
  //   id: "Production",
  //   type: "Production",
  // }];
  // const handleChangeCategoryType = (selectedOption) => {
  //   setCategoryType(selectedOption.label);
  // };
  // const GetCategoryTypeList = categoryTypeData.map((x) => {
  //   let data = { value: x.id, label: x.type };
  //   return data;
  // });

  useEffect(() => {
    props.setHeading("New Category");
    props.getRestaurantData();
    // props.getWarehouseApi();
  }, []);

  return (
    <>
      {props.isAddingCategory || props.isFetchingRestaurant ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("SelectCompany")} *</b></Form.Label>
                <Select
                  value={{ label: restaurantName }}
                  placeholder="Select Company"
                  onChange={handleChangeRestaurant}
                  options={getRetaurantList}
                />
              </Form.Group>
            </Col>
            {/* <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("SelectCategoryType")} *</b></Form.Label>
                <Select
                  placeholder="Select Category Type"
                  onChange={handleChangeCategoryType}
                  options={GetCategoryTypeList}
                />
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>{t("CategoryName")} *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Category Name"
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(restaurantName) || _.isEmpty(category) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadCategory}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    // getWarehouseApi: () => dispatch(getWarehouseApi()),
    getRestaurantData: () => dispatch(getRestaurantData()),
    AddCategoryApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddCategoryApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingCategory: state.CategoryReducer.isAddingCategory,
  // warehouseList: state.WarehouseReducer.warehouseList,
  isFetchingRestaurant: state.ResturantReducer.isFetchingRestaurant,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory);